import React from "react";
import "./footer.scss";
import euImage from "../../assets/images/EN_FundedbytheEU_RGB_NEG-300x67.png";

const Footer = () => {
  return (
    <footer className="custom-footer">
      <div className="euFunding">
        <img className="euImage" src={euImage} alt="EU Funding Logo" />
        <p className="euText">
          The ONCOSCREEN is funded by the European Union’s Horizon Europe
          research and innovation programme under grant agreement No. 101097036.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
